<template>
  <!-- 详情 or 审核 -->
  <div class="supplier_detail" v-loading="loading">
    <back />

    <div class="content globle_border">
      <el-form ref="form" class="form" :model="form" label-position="left" label-width="170px" disabled>
        <div class="title1">供应商信息</div>
        <el-form-item label="供应商名称">
          <el-input v-model="form.supplierName"></el-input>
        </el-form-item>
        <el-form-item label="营业执照">
          <el-image class="busilicense" fit="cover" :src="form.busiLicense" :preview-src-list="[form.busiLicense]"></el-image>
        </el-form-item>
        <!-- <el-form-item label="Logo">
          <el-image class="busilicense" fit="cover" :src="form.logoPic" :preview-src-list="[form.logoPic]"></el-image>
        </el-form-item> -->
        <el-form-item label="统一社会信用代码">
          <el-input v-model="form.creditCode"></el-input>
        </el-form-item>
        <el-form-item label="联系人">
          <el-input v-model="form.contacts"></el-input>
        </el-form-item>
        <el-form-item label="联系电话">
          <el-input v-model="form.telphone"></el-input>
        </el-form-item>
        <el-form-item label="供应商地址">
          <el-input v-model="form.local"></el-input>
        </el-form-item>
        <el-form-item label="供应商简介">
          <el-input type="textarea" v-model="form.supplierIntroduce" :autosize="{ minRows: 5, maxRows: 15 }"></el-input>
        </el-form-item>
        <el-form-item label="审核状态" v-if="audit == 1">
          <el-input v-model="options[form.status]"></el-input>
        </el-form-item>
        <el-form-item label="审核时间" v-if="audit == 1">
          <el-input v-model="form.status"></el-input>
        </el-form-item>
        <el-form-item label="不通过原因" v-if="audit == 1 && status == 2">
          <el-input v-model="form.loseContent"></el-input>
        </el-form-item>
      </el-form>
    </div>

    <div class="btn" v-if="audit == 1 && status == 0">
      <el-button type="danger" @click="dialogVisible = true">不通过</el-button>
      <el-button type="primary" @click="passAudit">通过</el-button>
    </div>

    <el-dialog title="审核不通过原因" :visible.sync="dialogVisible" :before-close="onCancel" :close-on-click-modal="false">
      <el-input type="textarea" v-model="loseContent" placeholder="请输入内容" maxlength="200" show-word-limit :autosize="{ minRows: 5, maxRows: 6 }"></el-input>
      <span slot="footer" class="dialog-footer">
        <el-button @click="onCancel">取 消</el-button>
        <el-button type="primary" @click="onConfirm">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      loading: false,
      id: null,
      audit: 0, // 0 详情 1 审核详情
      status: null, // 0 待审核 1 通过 2 不通过
      options: { 0: "待审核", 1: "审核通过", 2: "审核不通过" },
      tableData: [],
      form: {
        supplierName: "",
        contacts: "",
        logoPic: "",
        telphone: "",
        supplierIntroduce: "",
        busiLicense: "",
        creditCode: "",
        financeName: "",
        financePhone: "",
      },
      loseContent: "",
      dialogVisible: false,
    }
  },
  created() {
    this.id = this.$route.query.id
    this.audit = this.$route.query.audit || 0
    this.status = this.$route.query.status || null
    this.getSupplierDetail()
  },
  methods: {
    // 详情
    getSupplierDetail() {
      this.loading = true
      this.$axios
        .get(`${this.$api.supplierInfoSupplierDetail}/${this.id}`)
        .then(res => {
          const { result } = res
          this.form = result
          this.form.local = result.province + result.city + result.area + result.address
          this.loading = false
        })
        .catch(err => {
          this.loading = false
          this.$message.error(err.desc)
        })
    },
    // 通过
    passAudit() {
      this.$confirm(`确认通过?`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        center: true,
      })
        .then(() => {
          this.loading = true
          this.$axios
            .post(this.$api.supplierInfoAudit, {
              supplierId: this.id,
              status: 1,
            })
            .then(res => {
              this.loading = false
              this.$message.success("操作成功")
              setTimeout(() => {
                this.$router.go(-1)
              }, 1000)
            })
            .catch(err => {
              this.loading = false
              this.$message.error(err.desc)
            })
        })
        .catch(() => {})
    },
    // 不通过
    onConfirm() {
      if (this.loseContent == "") {
        this.$message.error("请填写不通过原因")
      } else {
        this.loading = true
        this.$axios
          .post(this.$api.supplierInfoAudit, {
            supplierId: this.id,
            loseContent: this.loseContent,
            status: 2,
          })
          .then(res => {
            this.dialogVisible = false
            this.loading = false
            this.$message.success("操作成功")
            setTimeout(() => {
              this.$router.go(-1)
            }, 1000)
          })
          .catch(err => {
            this.loading = false
            this.$message.error(err.desc)
          })
      }
    },
    onCancel() {
      this.loseContent = ""
      this.dialogVisible = false
    },
  },
}
</script>

<style scoped lang="scss">
.supplier_detail {
  .content {
    padding: 60px 190px;

    .form {
      width: 900px;
      margin: 0 auto;

      .title1 {
        position: relative;
        font-weight: bold;
        margin-bottom: 40px;
      }

      .title1::before {
        content: "";
        position: absolute;
        top: 0;
        left: -12px;
        width: 4px;
        height: 22px;
        background-color: #069bbc;
      }

      ::v-deep .el-form-item__label {
        color: #272727;
        font-size: 16px;
        padding-right: 40px;
      }

      ::v-deep .el-input__inner,
      ::v-deep .el-textarea__inner {
        background: #fff;
        border-radius: 10px;
        border: 1px solid #e5e7e6;
      }

      ::v-deep .el-input.is-disabled .el-input__inner,
      ::v-deep .el-textarea.is-disabled .el-textarea__inner {
        color: #1a1a1a;
      }

      .logo {
        display: block;
        width: 100px;
        height: 100px;
        border-radius: 4px;
      }

      .busilicense {
        display: block;
        width: 133px;
        height: 100px;
        border-radius: 4px;
      }
    }
  }
  .btn {
    display: flex;
    justify-content: space-between;
    width: 200px;
    margin: 0 auto;
  }
}
</style>
